import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function search({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M13.793 13.793a1 1 0 011.414 0l5.5 5.5a1 1 0 01-1.414 1.414l-5.5-5.5a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        fillRule="evenodd"
        d="M10 5a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default search;
